var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Link as FluentLink } from "@fluentui/react";
import { useContext } from "react";
import { HashimukhContext } from "../../index";
import { Text } from "../texts/Text";
export var Link = function (props) {
    var printView = props.printView, forwardProps = __rest(props, ["printView"]);
    var context = useContext(HashimukhContext);
    if (context.inPrintMode) {
        return printView ? printView : _jsx(Text, { children: props.children }, void 0);
    }
    else {
        return _jsx(FluentLink, __assign({}, forwardProps, { children: props.children }), void 0);
    }
};
//# sourceMappingURL=Link.js.map